"use client";

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CardOrderDetailContent from "./cardOrderDetailContent";

export default function CardOrderDetailView() {
  const navigate = useNavigate();
  const location = useLocation();
  const paymentMethod =
    location.state && typeof location.state.paymentMethod === "string"
      ? location.state.paymentMethod
      : "Card";
	const recieptno = location.state?.recieptno || null;

  return <CardOrderDetailContent navigate={navigate} paymentMethod={paymentMethod} recieptno={recieptno} />;
}
